import grga from "../images/Grga.jpeg";
import alen from "../images/Alen.jpeg";

export const founders = [
    {
        name: "Alen Čaljkušić",
        role: "Senior Platform Engineer / DevOps & Cloud Specialist",
        image: alen,
        description: `
            Over 10 years of industry experience in developer, DevOps, SRE, and platform engineering roles. Worked for companies ranging from startups to some of the biggest IT companies out there such as Ericsson and Activision Blizzard. Deeply passionate about Linux, Cloud, and related technologies. Certified as an AWS Solutions Architect – Professional and fully certified in Kubernetes.
        `,
    },
];
